<template>
  <div>
    <Socials />
    <Main />
  </div>
</template>

<script>
import Main from '@/components/Main.vue'
import Socials from '@/components/socials.vue'

export default {
  name: 'GalleryView',
  components: {
    Main,
    Socials
  }
}
</script>